import { render, staticRenderFns } from "./role-manage.vue?vue&type=template&id=9726db46&scoped=true"
import script from "./role-manage.vue?vue&type=script&lang=js"
export * from "./role-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9726db46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9726db46')) {
      api.createRecord('9726db46', component.options)
    } else {
      api.reload('9726db46', component.options)
    }
    module.hot.accept("./role-manage.vue?vue&type=template&id=9726db46&scoped=true", function () {
      api.rerender('9726db46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/role/role-manage.vue"
export default component.exports